export default {
  childrenData: [], // children list
  favoriteSkills: [],
  childrenDataFormatted: [],
  dailyGoal: true,
  childrenOrder: [], // ordered  list of children id
  childChallengeOrder: {},
  childsCliniciansReport: [],
}